export const CHANGE_MAP_SCALE = 'CHANGE_MAP_SCALE';
export const CHANGE_MAP_STATE = 'CHANGE_MAP_STATE';
export const SET_MIN_MAX_SCALE = 'SET_MIN_MAX_SCALE';
//# sourceMappingURL=constants.js.map